import React from 'react';

import styles from './pure.module.css';

type ButtonProps = {
  size: 'lg' | 'md' | 'sm';
  color: 'primary' | 'secondary';
  classes?: string;
  fullScreen?: boolean;
  type?: 'link' | 'button' | 'anchor';
  href?: string;
  onClick?: () => void;
  children: React.ReactNode | string;
};

export default function Button({
  size,
  color,
  children,
  classes,
  fullScreen,
  type,
  href,
  onClick,
}: ButtonProps) {
  const widthStyle = fullScreen ? 'w-full' : styles['w-fit'];
  const commonButtonStyles = 'flex py-2.5 px-4 justify-center items-center rounded text-center';
  const sizeStyles = {
    lg: 'px-4 py-2.5 h-44px text-base',
    md: 'h-34px px-4 text-sm',
    sm: 'p4 h-7 text-xs',
  };
  const typeStyles = {
    primary:
      'bg-rp-primary-redesign hover:bg-rp-primary-hover active:bg-rp-primary-pressed text-rp-inverted',
    secondary:
      'bg-rp-inverted hover:bg-rp-inverted-hover active:bg-rp-inverted-pressed border border-rp-primary-redesign text-rp-primary-redesign',
  };

  return type === 'button' ? (
    <button
      type="button"
      className={`${commonButtonStyles} ${typeStyles[color]} ${sizeStyles[size]} ${widthStyle} ${classes}`}
      onClick={onClick}
    >
      {children}
    </button>
  ) : (
    <button
      type="button"
      onClick={() => {
        window.open(href!, type === 'link' ? '_blank' : '_self', 'noreferrer');
      }}
      className={`${commonButtonStyles} ${typeStyles[color]} ${sizeStyles[size]} ${widthStyle} ${classes}`}
    >
      {children}
    </button>
  );
}

Button.defaultProps = {
  classes: false,
  fullScreen: false,
  type: 'button',
  href: '',
  onClick: () => null,
};
